import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuillEditor = _resolveComponent("QuillEditor", true)!

  return (_openBlock(), _createBlock(_component_QuillEditor, {
    ref: "editor",
    content: _ctx.modelValue,
    "onUpdate:content": _ctx.updateContent,
    theme: "snow",
    options: _ctx.options,
    "content-type": "html",
    placeholder: "请输入...",
    style: {"width":"100%","height":"300px"}
  }, null, 8, ["content", "onUpdate:content", "options"]))
}